import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchNotifications,
  fetchUnreadNotificationCount,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  INotificationItem,
} from "./callbacks";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";

export const useGetNotifications = () => {
  return useQuery({
    queryKey: [API_ENDPOINTS.NOTIFICATION_LIST],
    queryFn: async () => {
      const res = await fetchNotifications();
      return res.data;
    },
    refetchInterval: 15000, // Auto refresh every 15 seconds
  });
};

export const useGetUnreadNotificationCount = () => {
  return useQuery({
    queryKey: [API_ENDPOINTS.NOTIFICATION_UNREAD_COUNT],
    queryFn: async () => {
      const res = await fetchUnreadNotificationCount();
      return res.data;
    },
    refetchInterval: 15000,
  });
};

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await markNotificationAsRead(id);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.NOTIFICATION_LIST] });
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.NOTIFICATION_UNREAD_COUNT] });
    },
  });
};

export const useMarkAllNotificationsAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await markAllNotificationsAsRead();
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.NOTIFICATION_LIST] });
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.NOTIFICATION_UNREAD_COUNT] });
    },
  });
};
